import React from "react";
import { NavBar } from "./TopNavBar/NavBar";
import TopBanner from "./TopBanner";

const Header = () => (
  <>
    {/* Skip link for accessibility */}
    <a href="#main-content" className="skip-link">
      דלג לתוכן הראשי
    </a>
    <TopBanner />
    <NavBar />
  </>
);

export default Header;
